import { render, staticRenderFns } from "./edit.profile_notification.page.vue?vue&type=template&id=34c6c766&"
import script from "./edit.profile_notification.page.vue?vue&type=script&lang=js&"
export * from "./edit.profile_notification.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports